module.exports = __webpack_public_path__ + "img/01_full.fe95a749.jpg";